<template>
  <div>
    
    <QuizEditorNav />
    <QuizStepper step="2" />
    <div class="container loader" :class="{hidden: !quizLoading}">
      <div class="progress">
        <div class="indeterminate"></div>
      </div>
    </div>
    <div class="container" :class="{hidden: quizLoading}">
      <div class="col s12 m7">
        <br />
        <br />
        <div class="card horizontal">
          <div class="card-image blue" style="width:40px">
            <p>
              <i class="material-icons" style="font-size:40px;color:#fff">code</i>
            </p>
          </div>
          <div class="card-stacked">
            <div class="card-content">
              <a
                style="color:#000"
                v-bind:href="'/quizzes/build/'+id"
              >Data entry: ({{collect_user_information}})</a>
            </div>
          </div>
        </div>
        <div id="modalSuccessCritera" class="modal">
          <div class="modal-content">
            <h4>Quiz Success Criteria</h4>
            <p>Select the minimum number of correct answers required to pass: </p>
            <p class="range-field">
              <input type="range" id="success_score" step="1" v-model="minimum_correct_answers_to_pass" min="0" :max="questions.length" />
              Quiz takers will need to get <output for="fader" id="success_score"><span style="background-color:#e3e3e3"><b>{{minimum_correct_answers_to_pass}}</b></span></output> question(s) correct to pass.
              
            </p>
          </div>
          <div class="modal-footer">
            <a href="#!" @click="minimum_correct_answers_to_pass=original_minimum_correct_answers_to_pass" class="modal-close waves-effect waves-green btn-flat">Cancel</a>
            <a href="#!" @click="saveNumberOfCorrectAnswersToPass()" class="modal-close waves-effect waves-green btn-flat">Save</a>
          </div>
        </div>
        <div class="card horizontal" v-if="questions.length !=0">
          <div class="card-image blue center" style="width:40px">
            <p>
              <i class="material-icons" style="font-size:30px;color:#fff">done_all</i>
            </p>
          </div>
          <div class="card-stacked" >
            <div class="card-content">
              <a class="modal-trigger"
                style="color:#000"
                href="#modalSuccessCritera"
              >Success Criteria  - Number of correct answers required to pass:  <b>{{minimum_correct_answers_to_pass}}/{{questions.length}}</b></a>
              <a
                    class="modal-trigger" style="color:#000"
                    onMouseOver="this.style.cursor='pointer'"
                    href="#modalSuccessCritera"
                  ><i class="material-icons right" style="font-size:20px;">edit</i></a>
            </div>
          </div>
        </div>
        <br>
        Questions
        <a
            class="dropdown-trigger btn-flat right waves-effect waves-light"
            :class="[{disabled: addingQuestion && !canGoNext}]"
            style="margin-top:-10px"
            href="#"
            data-target="dropdown1">
            Add Question
            <i class="material-icons right" v-if="!loadingSteps">add</i>
          </a>
          
        <hr>

        <ul id="sortable">
          <li style="border-style:none !important;"
            :key="i"
            v-for="(question, i) in questions"
            
            class="ui-state-default"
            :data-order="i"
            :id="question.id"
          >
            <div class="card horizontal">
              <div class="card-image" style="width:40px;text-align:center"
              :style="{backgroundColor: colors[i%colors.length] }">
                <p>
                  <span style="font-size:30px;color:#fff">{{i+1}}</span>
                </p>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <a class="modal-trigger"
                    style="color:#000"
                    href="#modal1"
                    
                  >{{question.question}}</a>
                  <i class="material-icons right" style="font-size:20px;">dehaze</i>
                  <a 
                      onMouseOver="this.style.cursor='pointer'"
                      :data-id="question.id"
                      :data-title="question.question.replace(/_/g, ' ')"
                        v-on:click='deleteConfirm(question.id, question.question)'>
                  <i class="material-icons right" style="font-size:20px;">delete</i></a>
                  <a
                    style="color:#000"
                    onMouseOver="this.style.cursor='pointer'"
                    @click="function(evt){bubbaModal(question.id, evt)}"
                  ><i class="material-icons right" style="font-size:20px;">edit</i></a>
                 
                </div>
              </div>
            </div>
        </li>
        </ul>
        

        <div id="modal1" class="modal modal-fixed-footer">
          <div class="modal-content">
            <h4 v-if="question_id">Edit Question</h4>
            <h4 v-if="!question_id">Add New Question</h4>
            <h6>{{question_type.replace(/_/g, " ")}}</h6><hr>
            
              <div class="row">
                <form class="col s12">
                  <div class="row">
                    <br>
                    <div class="input-field col s12">
                      
                      <input v-model="title"
                        tabindex="1"
                        :maxlength="300"
                        placeholder="Enter the question here"
                        id="question"
                        type="text"
                        class="validate"
                        required
                      />
                     
                      <label for="question" class="active">Question</label>
                      <span class="right helper-text">{{title.length}} / 300</span>
                    <!--
                    checked:{{checked_answers}}<br>
                    correct:{{correct_answers}}<br>
                    choices:{{choices}}
                    -->
                    <h5>Options/Answers</h5>
                      <ul id="options">
                        <li style="border-style:none !important;"
                          :key="i"
                          v-for="(option, i) in choices">
                          <div v-if="question_type==='SINGLE_ANSWER'" class="row">
                            <div class="col s1">
                              <label>
                              <br><input name="group1" :id="'checked_'+ i" type="radio" :value="option" v-model="correct_answers" />
                              <span></span>
                              </label>
                            </div>
                            <div class="col s10 left-align"><input :id="'single_answer_'+i" type="text" :value="option" @change="syncOptions(i)"></div>
                            <div class="col s1"><br><i class="material-icons" @click="removeOption(i)">delete</i></div>
                          </div>

                           <div v-if="question_type==='MULTIPLE_CHOICE'" class="row">
                            <div class="col s1">
                              <label>
                              <br><input :id="'checked_'+ i" type="checkbox" :key="i" :value="option" v-model="checked_answers"  />
                              <span></span>
                              </label>
                            </div>
                            <div class="col s10 left-align"><input :id="'single_answer_'+i" type="text" :value="option" 
                                @change="syncOptions(i)">
                            </div>
                            <div class="col s1"><br><i class="material-icons" @click="removeOption(i)">delete</i></div>
                          </div>

                           <div v-else-if="question_type==='TRUE_OR_FALSE'"> 
                             <br>
                            <label>
                              <input name="group1" type="radio" :value="option" v-model="correct_answers" />
                              <span>{{option.replace(/^\w/, c => c.toUpperCase())}}</span>
                              <br>
                            </label>
                            
                          </div>
                          
                        
                        </li>
                        <div v-if="question_type==='SINGLE_ANSWER' || question_type==='MULTIPLE_CHOICE'" class="valign-wrapper">
                          <br><i class="material-icons" @click="addNewOption()">add</i>&nbsp;Option
                        </div>
                      </ul>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="switch">
                      <label>
                        <input type="checkbox" v-model="provide_explanation">
                        <span class="lever"></span>
                        Provide explanation for the answer
                      </label>
                    </div>
                    <br>
                    <div class="input-field col s12"
                         v-show="provide_explanation">
                      <textarea id="explanation" 
                        class="materialize-textarea"
                        
                        style="height:20px" 
                        v-model="explanation"></textarea>
                      <label id="labeler" for="explanation" class="active !important;">Correct answer explanation</label>
                    </div>
                    
                  </div>
                </form>
              </div>
            </div>
 
          <div class="modal-footer">
            <span v-if="!answerEntered" :class="!answerEntered?'red-text lighten-2':'green_text'">A question and an answer must be provided</span>
            <a
                  class="btn btn-flat waves-effect waves-light right"
                  :class="{disabled:!answerEntered}"
                  @click="saveQuestion()"
                >Save Question</a>
            <a href="#!" @click="addingQuestion=false" class="modal-close waves-effect waves-green btn-flat">Cancel</a>
          </div>
        </div>
        
        <div class="fab-next">
          <a
            class="btn blue"
            :class="[{disabled: !canGoNext}]"
            href="#"
            @click="proceedToPreview()">
            Preview Quiz
            <i class="material-icons right" >chevron_right</i> 
          </a>
        </div>
        
        <!--
        <a
            class="dropdown-trigger btn-flat right waves-effect waves-light"
            :class="[{disabled: addingQuestion && !canGoNext}]"
            style="margin-top:-10px"
            href="#"
            data-target="dropdown1">
            Add Question
            <i class="material-icons right" v-if="!loadingSteps">add</i>
          </a>
          -->
          <!--
        <div class="fab-next">
          <a
            class="dropdown-trigger btn blue"
            :class="[{disabled: addingQuestion && !canGoNext}]"
            href="#"
            data-target="dropdown1">
            Add Question
            <i class="material-icons right" v-if="!loadingSteps">chevron_right</i>
          </a>
        </div>
        -->
        
        
        
      </div>
      
      <ul id="dropdown1" class="dropdown-content">
        <li>
          <a href="#" @click="bubba('radio')" >
            <i class="material-icons">radio_button_unchecked</i>Single answer
          </a>
        </li>
        <li>
          <a href="#" v-on:click="bubba('select')">
            <i class="material-icons">check_box_outline_blank</i>Multiple choice
          </a>
        </li>
        <li>
          <a href="#" v-on:click="bubba('true_false')">
            <i class="material-icons">check</i>True or false
          </a>
        </li>
      </ul>
    </div>
    <div id="deleteModal" class="delete-modal modal">
      <div class="modal-content">
        <h5>Are you sure you want to delete this question?</h5>
        <p>{{ deleteTitle }}</p>
      </div>
      <div class="modal-footer">
        <a class="modal-action modal-close waves-effect waves-grey btn-flat">Cancel</a>
        <!-- <a href="#!" class="modal-action modal-close waves-effect waves-grey btn-flat red-text">Coming Soon!</a> -->
        <a  v-on:click="deleteQuestion" class="modal-action modal-close waves-effect waves-red red-text btn-flat">Delete</a>
      </div>
    </div>
  </div>
</template>
<script>
/*
  window.addEventListener("load", function () {  
      $( "#sortable" ).sortable({
        cancel: '.editable',
        update: function(event, ui) {
                    var productOrder = $(this).sortable('toArray');
                    let mutations=productOrder.map(GqlV2Query.questionOrderMutationBuilder).toString();
                    GqlV2Query.updateQuestionOrder(mutations, (err, result) => {
                      if (err) {
                        this.error = err;
                        M.toast({
                          html:
                            "There was an error updating your quiz, please try again or contact Fyiio support",
                          inDuration: 300,
                        });
                      } else {
                            M.toast({
                              html:
                                "Reordering the questions, please wait a moment....",
                                completeCallback: function(){
                                  let quiz_id=window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
                                  quiz_id=quiz_id.replace("#","").replace("!", "");
                                  window.location = "/quizzes/build/question/" + quiz_id;
                                },
                                inDuration: 100,
                                displayLength: 1250,
                                outDuration: 100,
                            });
                            
                      }
                    });
                },
        revert: true
      });
      $( "#draggable" ).draggable({
        connectToSortable: "#sortable",
        helper: "clone",
        revert: "invalid"
      });
      $( "ul, li" ).disableSelection();  
});
*/

import QuizEditorNav from "@/components/QuizEditorNav";
import QuizStepper from "@/components/QuizStepper";

import Sidebar from "@/components/Sidebar";
import cognitoAuth from "@/plugins/cognito";
import GqlQuery from "@/plugins/gql";
import GqlV2Query from "@/plugins/gqlV2";

import "isomorphic-fetch";

let gql_endpoint = process.env.GQL_ENDPOINT;
let gqlv2_endpoint = process.env.GQL_V2_ENDPOINT;
let read_gql_endpoint = process.env.READGQL_ENDPOINT;

var draftFields = [
  "steps",
  "description",
  "title",
  "time_to_complete",
  "video_url",
  "thumbnail_url",
  "browser_title",
  "raw_url",
  "video_duration",
];

  
export default {
  components: {
    QuizEditorNav,
    QuizStepper
  },
  mounted() {
    let jqueryui = document.createElement('script')
      jqueryui.setAttribute('src','https://code.jquery.com/ui/1.12.1/jquery-ui.js' )
      
      document.body.appendChild(jqueryui)
    let self = this;
    document.title = "fyiio | quiz editor";
    document.addEventListener("DOMContentLoaded", function () {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
    });
    setTimeout(function () {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
    }, 500);
    self.waitForUi()
    

    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function (err, user_attributes) {
          self.user_org = user_attributes["custom:organization_id"];
          self.user_email = user_attributes["email"];

          if (self.id) {
            self.quizLoading=true;
            self.loadQuiz();
          } else {
            self.quizLoading = false;
          }
        });
      }
    });
    
  },
  updated() {},
  name: "NewQuizTemplate",
  data() {
    return {
      colors: ["#25aae1", "#8cc63f", "#f172a6", "#13a89e", "#fcb040", "#8cc63f"],
      question:{},
      questions:[],
      updatingQuestion: false,
      record_user_results: true,
      title: "",
      question_id:"",
      question_type: "",
      explanation:"",
      provide_explanation: false,
      choices:{},
      correct_answers:[],
      checked_answers:[],
      description: "",
      time_to_complete: "",
      collect_user_information: "",
      minimum_correct_answers_to_pass:0,
      original_minimum_correct_answers_to_pass:0,
      quiz: "",
      id: this.$route.params.id,
      user_id: false,
      draft: false,
      user_org: false,
      originalQuiz: false,
      user_email: false,
      loadingSteps: false,
      addingQuestion: false,
      quizLoading: true,
      deleteId:"",
      deleteTitle:""

    };
  },
  computed: {
    answerEntered(){
      let answered=false
      if(this.title.length==0){
         return false;
      }
      if(!this.canGoNext){
        //May be first question being addedd
        if(this.correct_answers?.length==0 && this.checked_answers.length==0){
          return false
        }
      }
      if (Array.isArray(this.correct_answers)){
        if(this.correct_answers.length>0){
          answered=true
        }
      }else if(this.correct_answers.length>0){        
        answered=true;
      }
      if(this.question_type=="MULTIPLE_CHOICE" && this.checked_answers.length>0){
        answered=true
      }
      return answered
    },
    canGoNext() {
      return this.title.length>0 && this.questions.length>0 ;
      
    },
  },
  methods: {
    waitForUi(){
      let self=this;
      setTimeout(function () {
      if($("#sortable")==undefined){
        self.waitForUi()
      }else{
        self.initSortable()
      }
    }, 500);
    },
    initSortable(){
      $( "#sortable" ).sortable({
        cancel: '.editable',
        update: function(event, ui) {
                    var productOrder = $(this).sortable('toArray');
                    let mutations=productOrder.map(GqlV2Query.questionOrderMutationBuilder).toString();
                    
                    GqlV2Query.updateQuestionOrder(mutations, (err, result) => {
                      if (err) {
                        this.error = err;
                        M.toast({
                          html:
                            "There was an error updating your quiz, please try again or contact Fyiio support",
                          inDuration: 300,
                        });
                      } else {
                            M.toast({
                              html:
                                "Reordering the questions, please wait a moment....",
                                completeCallback: function(){
                                  let quiz_id=window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
                                  quiz_id=quiz_id.replace("#","").replace("!", "");
                                  window.location = "/quizzes/build/question/" + quiz_id;
                                },
                                inDuration: 100,
                                displayLength: 1250,
                                outDuration: 100,
                            });
                      }
                    });
                },
        revert: true
      });
      $( "#draggable" ).draggable({
        connectToSortable: "#sortable",
        helper: "clone",
        revert: "invalid"
      });
      $( "ul, li" ).disableSelection();  
    },
    removeOption(option_idx){
      let self=this;
      let holdval=self.choices[option_idx]
      if(self.question_type=="SINGLE_ANSWER"){
        if(!Array.isArray(self.correct_answers) && self.correct_answers==holdval){
          self.correct_answers=[]
        }
      }else{
        for(let i=0;i<=self.checked_answers.length;i++){
          if(self.checked_answers[i]==holdval){
            self.checked_answers.splice(i, 1);
          }
        }
      }
      self.choices.splice(option_idx, 1);

    },
    addNewOption(){
      let self=this;
      self.choices.push("New Option!")
    },
    syncOptions(idx){
      let self=this;
      let holdval=self.choices[idx];
      let newval=$("#single_answer_"+idx).val();
      self.choices[idx]=newval;
      let checker=$("#checked_" + idx).val();
      $("#checked_" + idx).val(newval);
      if(self.question_type=="SINGLE_ANSWER"){
        if(!Array.isArray(self.correct_answers) && self.correct_answers==holdval){
          self.correct_answers=newval;
        }
      }else{
        for(let i=0;i<=self.checked_answers.length;i++){
          if(self.checked_answers[i]==holdval){
            self.checked_answers[i]=newval;
          }
        }
      }
      self.$forceUpdate();
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    labeler(){
      $('#labeler').addClass('active');
      setTimeout(function(){ $('#labeler').addClass('active'); }, 1);
    },
    isAnswer(option){
      return this.correct_answers.includes(option);
    },
    camelCase(str) { 
            return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) 
            { 
                return index == 0 ? word.toLowerCase() : word.toUpperCase(); 
            }).replace(/\s+/g, ''); 
    }, 
    clearQuestion(){
      this.question_id=null;
      this.checked_answers=[];
      this.provide_explanation=false;
      this.explanation=null;
      this.title="";
      this.question_type="";
      this.correct_answers=JSON.parse("{\"correct_answers\":[]}");
      
      M.AutoInit();
    },
    bubba(valz) {
      this.addingQuestion = true;
      this.clearQuestion();
      if(valz=="true_false"){
        this.question_type="TRUE_OR_FALSE";
        this.choices= ["true","false"];
      }else if (valz=="radio"){
        this.question_type="SINGLE_ANSWER";
        this.choices=["Answer 1","Answer 2", "Answer 3"];
      }else if (valz=="select"){
        this.question_type="MULTIPLE_CHOICE";
        this.choices=["Answer 1","Answer 2", "Answer 3"];
      }
      
      $("#modal1").modal('open')
      //$("#modal1").modal({complete:function(){alert('close triggered')}})
    },
    
    bubbaModal(id, evt) {
      let self=this;
      GqlV2Query.getQuestion(id, (err, result) => {
          if (err) {
            this.error = err;
            M.toast({
              html:
                "There was an error fetching the question, please try again or contact Fyiio support",
              inDuration: 3000,
            });
          } else {
            let quest=result.data.question;
            self.question_id=quest.id;
            self.title=quest.question;
            self.question_type=quest.question_type;
            self.provide_explanation=quest.provide_explanation;
            self.explanation=quest.explanation;
            self.choices=quest.choices['choices'];
            self.correct_answers=quest.correct_answers['correct_answers'];
            if(self.question_type=="MULTIPLE_CHOICE"){
              self.checked_answers=self.correct_answers
            }else{
              self.correct_answers=self.correct_answers[0]
            }
            
            $("#modal1").modal('open');
            setTimeout(function(){ M.updateTextFields()}, 500);
          }
        });
    },
    saveQuestion(){
      let self=this;
      if(self.question_id){
        self.updateQuestion();
      }else{
        self.insertQuestion();
      }
    },
    proceedToPreview(){
      let self=this;
      window.location.href="/quizzes/preview/" + self.id
    },
    jsonify(label, arr){
      let returner={}
      if(Array.isArray(arr)){
        returner[`${label}`]=arr;
      }else{
        returner[`${label}`]=new Array(arr);
      }
      return returner;
    },
    insertQuestion(){
      let self=this;
      var holdArr=self.correct_answers;
      if(self.question_type=="MULTIPLE_CHOICE"){
        holdArr=self.checked_answers;
      }
      let variables = {
          quiz_id: self.id, 
          question: self.title,
          choices: self.jsonify("choices", self.choices), 
          correct_answers:self.jsonify("correct_answers", holdArr),
          question_type: self.question_type, 
          provide_explanation: self.provide_explanation,
          explanation: self.explanation
      };
      GqlV2Query.insertQuestion(variables, (err, result) => {
          if (err) {
            this.error = err;            
            M.toast({
              html:
                "There was an error updating your quiz, please try again or contact Fyiio support",
              inDuration: 3000,
            });
          } else {            
            M.toast({
              html: "Question saved!      Refreshing...",
              completeCallback: function(){$("#modal1").modal('close');window.location = "/quizzes/build/question/" + self.id},
              inDuration:500,
              displayLength: 1000,
              outDuration: 100,

            })
          }
        });

    },
    updateQuestion(){
      let self=this;
      let holdAnswers=self.correct_answers;
      if(self.question_type=="MULTIPLE_CHOICE"){
        self.correct_answers=self.checked_answers;
      }
      let variables = {
          id: self.question_id, 
          question: self.title,
          choices: self.jsonify("choices", self.choices),
          correct_answers:self.jsonify("correct_answers",self.correct_answers),
          question_type: self.question_type, 
          provide_explanation: self.provide_explanation,
          explanation: self.explanation
      };
      GqlV2Query.updateQuestion(variables, (err, result) => {
          if (err) {
            this.error = err;
            M.toast({
              html:
                "There was an error updating your quiz, please try again or contact Fyiio support",
              inDuration: 3000,
            });
          } else {
            M.toast({
              html: "Question saved!",
              completeCallback: function(){$("#modal1").modal('close');window.location = "/quizzes/build/question/" + self.id},
              inDuration:500
            })
            
          }
        });
    },
    deleteConfirm(id, question) {
      this.deleteId = id;
      this.deleteTitle = question;
      var options = {};
      var elem = document.querySelector('.delete-modal');

      // allow time for dom to react to data change
      setTimeout(function(){
        var instance = M.Modal.init(elem, options);
        instance.open();
      }, 10)
    },
    deleteQuestion(){
      let self=this;
      GqlV2Query.deleteQuestion(this.deleteId, (err, result) => {
          if (err) {
            this.error = err;
            M.toast({
              html:
                "There was an error deleting your quiz, please try again or contact Fyiio support",
              inDuration: 3000,
            });
          } else {
            M.toast({
              html: "Question deleted!",
              completeCallback: function(){window.location = "/quizzes/build/question/" + self.id},
              inDuration:300
            })
          }
        });
    },
    saveNumberOfCorrectAnswersToPass(){
      let self=this;
      self.original_minimum_correct_answers_to_pass=self.minimum_correct_answers_to_pass;
      let variables = {};
        variables.id = self.id;
        variables.minimum_correct_answers_to_pass = parseInt(self.minimum_correct_answers_to_pass)
        
        GqlV2Query.updateQuizPassCorrectAnswers(variables, (err, result) => {
          if (err) {
            this.error = err;
            M.toast({
              html:
                "There was an error updating your quiz, please try again or contact Fyiio support",
              inDuration: 3000,
            });
          } else {
             M.toast({
              html:
                "The number of correct answers required to pass has been successfully updated.",
              inDuration: 3000,
            });
          }
        });
    },
    loadQuiz() {
      let self = this;
      GqlV2Query.getQuiz(this.id, (err, result) => {
        
        let quiz = result.data.quiz[0];
        self.quiz = quiz;
        self.questions=quiz.questions
        self.originalQuiz = quiz;
        self.title = quiz.title;
        self.collect_user_information = quiz.collect_user_information;
        self.minimum_correct_answers_to_pass=quiz.minimum_correct_answers_to_pass;
        self.original_minimum_correct_answers_to_pass=quiz.minimum_correct_answers_to_pass;
        self.description = quiz.description;
        self.time_to_complete = quiz.time_to_complete;
        self.quizLoading = false;
        M.AutoInit();
      });
    },
    canSaveCurrentQuestion: function () {
      return question.title && question.title.length > 0
    },
    captureUserQuizResults() {
      var self = this;
      if (!this.canGoNext) {
        return;
      }
      this.loadingSteps = true;
      if (this.quiz) {
        let variablesOld = self.originalQuiz;
        let variables = {};
        variables.id = self.originalQuiz.id;
        variables.collect_user_information = self.collect_user_information;
        
        GqlV2Query.updateQuiz(variables, (err, result) => {
          if (err) {
            this.error = err;
            M.toast({
              html:
                "There was an error updating your quiz, please try again or contact Fyiio support",
              inDuration: 3000,
            });
          } else {
            window.location = "/quizzes/build/" + self.id;
          }
        });
      } else {
        
        let variables = {
          title: this.title,
          description: this.description,
          organization_id: this.organization_id,
          time_to_complete: this.time_to_complete,
        };
        GqlV2Query.newQuiz(variables, (err, result) => {
          if (err) {
            this.error = err;
          } else {
            window.location =
              "/quizzes/build/question/" + result.data.insert_quiz_one.id;
          }
        });
      }
    },
  },
};
</script>
<style scoped>

ul { list-style-type: none; margin: 0; padding: 0; margin-bottom: 00px; }
li { margin: 0px; padding: 0px; }
#toast-container {
  min-width: 10%;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  margin-top: -69px;
}
.preloader-wrapper {
  margin-top: 9px;
}
h2 {
  color: #58595b;
  font-family: Roboto;
  font-size: 24px;
  line-height: 32px;
  margin-top: 60px;
  margin-bottom: 24px;
}
button {
  margin-left: 10px;
}
.time-to-complete {
  width: 352px;
}
.time-to-complete label {
  left: 0;
}
.right.helper-text {
  text-align: right;
}
.hidden {
  display: none;
}
.loader {
  margin-top: 100px;
}
.select-wrapper input.select-dropdown,
.dropdown-content li > span {
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: lowercase;
}

.fab-next {
  float: right;
  padding-top: 42px;
  padding-bottom: 42px;
}
#description {
  margin-top: 8px;
}
</style>
<style >
#toast-container {
  top: auto !important;
  right: auto !important;
  bottom: 50%;
  left:37%;  
}
.select-wrapper input.select-dropdown {
  text-transform: lowercase !important;
}
.select-wrapper .dropdown-content li > span,
ul.dropdown-content.select-dropdown li span {
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: lowercase;
}
.btn-floating.blue {
  background-color: #58595b !important;
}
.btn-floating.blue.disabled {
  background-color: #f1f1f1 !important;
}

.progress {
  background-color: #7ac7e7;
}
.progress .determinate,
.progress .indeterminate {
  background-color: #29abe1;
}
</style>


// WEBPACK FOOTER //
// src/containers/dashboard/quizzes/BuildQuizAddQuestion.vue